import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth';
import league from './modules/league';
import week from './modules/week'
import weeklyscores from './modules/weeklyscores'
import suddendeath from './modules/suddendeath'
import chat from './modules/chat'
import mystats from './modules/mystats'
import preferences from './modules/preferences'
import settings from './modules/settings'
import ticker from './modules/ticker'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    league,
    week,
    weeklyscores,
    suddendeath,
    chat,
    mystats,
    preferences,
    settings,
    ticker,
  }
})
